import Checkbox, {CheckboxProps} from '@mui/material/Checkbox';
import {styled} from '@mui/material/styles';

export const CCheckbox = styled(Checkbox)<CheckboxProps>(
  (/* { theme } */) => ({
  }),
);
